import { render, staticRenderFns } from "./NsPayment.vue?vue&type=template&id=16a698be&"
import script from "./NsPayment.vue?vue&type=script&lang=js&"
export * from "./NsPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsButton: require('/usr/app/src/components/ns/NsButton.vue').default})
